import { FunctionComponent } from "react";
import styles from "./MultiStepProgress.module.scss";

type ownProps = {
  page: number;
  stepNames: Array<string>;
};

const MultiStepProgress: FunctionComponent<ownProps> = (props) => {
  const { page, stepNames } = props;
  const widthPercent = 100 / stepNames.length - 1;
  return (
    <ul className={styles.processNav}>
      {stepNames.map((stepName, i) => (
        <li
          key={i}
          className={
            (page >= i ? styles.active : "") +
            " " +
            (i < stepNames.length - 1 ? styles.arrow : "")
          }
          style={{ width: widthPercent + "%", marginRight: 2 }}
        >
          <span>{stepName}</span>
        </li>
      ))}
    </ul>
  );
};

export { MultiStepProgress, MultiStepProgress as default };
